"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Venmo = void 0;
var _SVG = require("../SVG");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Venmo = props => /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#Venmo_svg__a)"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#008CFF",
  fillRule: "evenodd",
  d: "M0 6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6Z",
  clipRule: "evenodd"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#fff",
  d: "M16.494 7.5c.349.6.506 1.219.506 2 0 2.491-2.041 5.727-3.698 8H9.518L8 8.046l3.313-.328.803 6.727c.75-1.272 1.675-3.272 1.675-4.635 0-.747-.123-1.255-.315-1.674l3.018-.636Z"
})), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "Venmo_svg__a"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
exports.Venmo = Venmo;
Venmo.displayName = "Venmo";